// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreadCard_container__Df9I5 {
  margin-bottom: 0.5em;
  border: 2px solid transparent;
  border-radius: 4px;
  transition: 300ms;
}
.ThreadCard_container__Df9I5:last-child {
  margin-bottom: 0;
}
.ThreadCard_containerHover__2j0kO {
  border: 2px solid #00b28d;
  border-radius: 4px;
}
.ThreadCard_root__doB6W {
  min-width: 1em;
  transition: 300ms;
  padding: 1em;
  background-color: #f5f5f5;
}
.ThreadCard_rootHover__xoO\\+Y {
  background-color: #ffffff;
}
.ThreadCard_cardContent__reYyt:first-child {
  padding-bottom: 0 !important;
}
.ThreadCard_cardContent__reYyt:last-child {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.ThreadCard_cardHeader__rxxfr {
  display: flex;
  justify-content: space-around;
  margin: 0.5em;
}
.ThreadCard_title__Avk8d {
  font-size: 14;
  font-weight: bold;
}
.ThreadCard_pos__jOauw {
  margin-bottom: 12;
}
.ThreadCard_headerText__ORr34 {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 400;
  margin-right: 0.5ch;
  -webkit-user-select: none;
          user-select: none;
}
.ThreadCard_headerValue__Obi\\+A {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 700;
  text-align: right;
}
.ThreadCard_fatText__8lA2n {
  font-weight: bold;
}
.ThreadCard_formControl__Vkr\\+I {
  min-width: 90% !important;
  margin-top: 1em;
  margin-bottom: -20px;
}
.ThreadCard_formControlSecondaryContainer__lyHm7 {
  margin-top: 0.2em;
  margin-bottom: 1em !important;
}
.ThreadCard_formControlSecondary__k33Kn {
  min-width: 90% !important;
}
.ThreadCard_formControlSecondary__k33Kn:hover {
  border-color: #00b28d !important;
  color: #00b28d;
}
.ThreadCard_formControlInput__mNqfw {
  color: #00b28d;
}
.ThreadCard_selectEmpty__lqbCh {
  margin-top: 1em;
}
.ThreadCard_expand__Cmjmr {
  transform: rotate(0deg);
  margin-right: auto;
  transition: 500ms;
}
.ThreadCard_expandOpen__v-Z\\+p {
  transform: rotate(180deg);
}
.ThreadCard_expandContainer__T0KOs {
  display: flex;
}
.ThreadCard_smallText__j8NJ3 {
  font-size: 0.75em !important;
  hyphens: auto;
  word-wrap: auto;
  margin-bottom: 1em;
}
.ThreadCard_selectEmpty__lqbCh {
  margin-top: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/ThreadSelector/ThreadCard/ThreadCard.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;AACf;AACA;EACE,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB","sourcesContent":[".container {\n  margin-bottom: 0.5em;\n  border: 2px solid transparent;\n  border-radius: 4px;\n  transition: 300ms;\n}\n.container:last-child {\n  margin-bottom: 0;\n}\n.containerHover {\n  border: 2px solid #00b28d;\n  border-radius: 4px;\n}\n.root {\n  min-width: 1em;\n  transition: 300ms;\n  padding: 1em;\n  background-color: #f5f5f5;\n}\n.rootHover {\n  background-color: #ffffff;\n}\n.cardContent:first-child {\n  padding-bottom: 0 !important;\n}\n.cardContent:last-child {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.cardHeader {\n  display: flex;\n  justify-content: space-around;\n  margin: 0.5em;\n}\n.title {\n  font-size: 14;\n  font-weight: bold;\n}\n.pos {\n  margin-bottom: 12;\n}\n.headerText {\n  font-size: 13px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 400;\n  margin-right: 0.5ch;\n  user-select: none;\n}\n.headerValue {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 700;\n  text-align: right;\n}\n.fatText {\n  font-weight: bold;\n}\n.formControl {\n  min-width: 90% !important;\n  margin-top: 1em;\n  margin-bottom: -20px;\n}\n.formControlSecondaryContainer {\n  margin-top: 0.2em;\n  margin-bottom: 1em !important;\n}\n.formControlSecondary {\n  min-width: 90% !important;\n}\n.formControlSecondary:hover {\n  border-color: #00b28d !important;\n  color: #00b28d;\n}\n.formControlInput {\n  color: #00b28d;\n}\n.selectEmpty {\n  margin-top: 1em;\n}\n.expand {\n  transform: rotate(0deg);\n  margin-right: auto;\n  transition: 500ms;\n}\n.expandOpen {\n  transform: rotate(180deg);\n}\n.expandContainer {\n  display: flex;\n}\n.smallText {\n  font-size: 0.75em !important;\n  hyphens: auto;\n  word-wrap: auto;\n  margin-bottom: 1em;\n}\n.selectEmpty {\n  margin-top: 1em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ThreadCard_container__Df9I5`,
	"containerHover": `ThreadCard_containerHover__2j0kO`,
	"root": `ThreadCard_root__doB6W`,
	"rootHover": `ThreadCard_rootHover__xoO+Y`,
	"cardContent": `ThreadCard_cardContent__reYyt`,
	"cardHeader": `ThreadCard_cardHeader__rxxfr`,
	"title": `ThreadCard_title__Avk8d`,
	"pos": `ThreadCard_pos__jOauw`,
	"headerText": `ThreadCard_headerText__ORr34`,
	"headerValue": `ThreadCard_headerValue__Obi+A`,
	"fatText": `ThreadCard_fatText__8lA2n`,
	"formControl": `ThreadCard_formControl__Vkr+I`,
	"formControlSecondaryContainer": `ThreadCard_formControlSecondaryContainer__lyHm7`,
	"formControlSecondary": `ThreadCard_formControlSecondary__k33Kn`,
	"formControlInput": `ThreadCard_formControlInput__mNqfw`,
	"selectEmpty": `ThreadCard_selectEmpty__lqbCh`,
	"expand": `ThreadCard_expand__Cmjmr`,
	"expandOpen": `ThreadCard_expandOpen__v-Z+p`,
	"expandContainer": `ThreadCard_expandContainer__T0KOs`,
	"smallText": `ThreadCard_smallText__j8NJ3`
};
export default ___CSS_LOADER_EXPORT___;
